import { render, staticRenderFns } from "./Glitch.vue?vue&type=template&id=8c86cd58&scoped=true&"
import script from "./Glitch.vue?vue&type=script&lang=js&"
export * from "./Glitch.vue?vue&type=script&lang=js&"
import style0 from "./Glitch.vue?vue&type=style&index=0&id=8c86cd58&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c86cd58",
  null
  
)

export default component.exports